import type { Component } from "solid-js";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { Button } from "~/solidJs/shared/ui";
import ArrowIcon from "~/solidJs/shared/ui/atoms/Icons/arrow.svg?component-solid";
export type TariffBenefitsAirtable = {
	userGroup: string;
	Title: string;
	Features: string;
};

export type TariffBenefits = {
	userGroup: string;
	Title: string;
	Features: { label: string }[];
};

export type UnsubscribeQuestionItemBase = {
	label: string;
	nameId: string;
};
export type UnsubscribeQuestionBoolItem = {
	type: "bool";
} & UnsubscribeQuestionItemBase;
export type UnsubscribeQuestionTextItem = {
	type: "text";
} & UnsubscribeQuestionItemBase;
export type UnsubscribeQuestionEnumItem = {
	type: "enum" | "enum-mult";
	variants: {
		label: string;
		value: string;
	}[];
} & UnsubscribeQuestionItemBase;
type UnsubscribeQuestionFiledUnion =
	| UnsubscribeQuestionBoolItem
	| UnsubscribeQuestionTextItem
	| UnsubscribeQuestionEnumItem;
export type UnsubscribeQuestionItem = {
	variantName: string;
	variantNameId: string;
	fields: Array<UnsubscribeQuestionFiledUnion>;
	anyRequiredFields?: Array<{
		fieldId: string;
	}>;
	eachRequiredFields?: Array<{
		fieldId: string;
	}>;
};
export type UnsubscribeQuestionAirtableItem = {
	variantName: string;
	variantNameId: string;
	fields: string;
	anyRequiredFields: string;
	eachRequiredFields: string;
};
type UnsubscribeQuestionsPageProps = {
	setIsVisible: (newVal: boolean) => void;
};
export const UnsubscribeQuestionsPage: Component<UnsubscribeQuestionsPageProps> = (props) => {
	return (
		<section class="relative flex h-full w-full items-center justify-center">
			<div class="-translate-x-1/2 -translate-y-10 absolute top-0 left-1/2 rounded-b-3xl bg-interaction-violet p-8 text-3xl text-white">
				Downgrade
			</div>
			<Button
				class="absolute top-0 left-0"
				onClick={() => {
					EventAnalytics.unsubscribe.backToPlansBtnClick();
					props.setIsVisible(false);
				}}
			>
				<ArrowIcon />
				Back to Plans
			</Button>
		</section>
	);
};
